import { h, Component } from 'preact';
import cx from 'classnames';
import * as Validators from '../../../../utils/forms/validators';
import hopplerLinkState from '../../../../utils/forms/hoppler-linkstate';
import { Listing } from '../../../../../types';
import { Form } from '../../../../utils/forms/form';
import { Subject } from 'rxjs';
import { getUserType } from '../../../../utils/listing-utils';
import { User } from '../../../../../types';

interface ListingEditorAlternativeContactSectionProps {
  listing?: Listing;
  isPending?: number;
  form?: Form;
  formSubject?: Subject<Form>;
  currentUser?: User;
}

interface ListingEditorAlternativeContactSectionState {}

export class ListingEditorAlternativeContactSection extends Component<ListingEditorAlternativeContactSectionProps, ListingEditorAlternativeContactSectionState> {
  getContactDetails(listing: Listing, form: Form, currentUser: User, isPending: number) {
    const isAssigned = Boolean(listing.salesDirectorProfile);
    var userType = getUserType(currentUser, listing);
    var details = {
      name: '*****',
      email: '*****',
      number: '*****'
    };
    if (listing.canEdit || isPending == 1) {
      details.name = form.fields['contactName'].value
      details.number = form.fields['contactNumber'].value
      details.email = form.fields['contactEmail'].value
    } else if (['internal_sales_director', 'external_sales_director', 'external_manager'].includes(userType) && isAssigned) {
      return details;
    } else if (['external_sales_director', 'external_manager'].includes(userType) && !isAssigned) {
      return details;
    } else {
      details.name = listing.contactName;
      details.email = listing.contactEmail;
      details.number = listing.contactNumber;
    }
    return details;
  }

  render() {

    const { 
      listing,
      isPending,
      formSubject,
      form,
      currentUser } = this.props;
    const contactDetails = this.getContactDetails(listing, form, currentUser, isPending)

    return (
      <div className="row mt-4 hi-listing-editor-modal__editor__alt-contact">
        <div className="col-12">
          <div className="hi-input-group">
            <label className="hi-input-group__label">Alternative Contact Person</label>
            <input
              disabled={ isPending == 1 || !listing.canEdit }
              className={ cx('form-control hi-text-input',
                {
                  'invalid': Validators.cxValidateField(form.fields['contactName'])
                })
              }
              value={ contactDetails.name }   
              placeholder="Name" 
              type="text"
              onInput={ hopplerLinkState(formSubject, form, 'contactName') }/>
          </div>
        </div>

        <div className="col-12 mt-4">
          <div className="hi-input-group">
            <label className="hi-input-group__label">Alternative Contact Person's Contact Number</label>
            <input
              disabled={ isPending == 1 || !listing.canEdit }
              className={ cx('form-control hi-text-input',
                {
                  'invalid': Validators.cxValidateField(form.fields['contactNumber'])
                })
              }
              value={ contactDetails.number }
              placeholder="Contact Number" 
              type="text"
              onInput={ hopplerLinkState(formSubject, form, 'contactNumber') }/>
          </div>
        </div>

        <div className="col-12 mt-4">
          <div className="hi-input-group">
            <label className="hi-input-group__label">Alternative Contact Person's Email Address</label>
            <input 
              disabled={ isPending == 1 || !listing.canEdit }
              className={ cx('form-control hi-text-input',
                {
                  'invalid': Validators.cxValidateField(form.fields['contactEmail'])
                })
              }
              value={ contactDetails.email } 
              placeholder="Email Address" 
              type="text"
              onInput={ hopplerLinkState(formSubject, form, 'contactEmail') }/>
          </div>
        </div>
      </div>
    )
  }
}